import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import Header from "../components/Header";
import { Card } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Se o e-mail existir, enviaremos as instruções.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-28 max-w-md mx-auto px-4">
        <Card className="p-8 gold-border">
          <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Recuperar senha</div>
          <h1 className="font-display text-3xl font-bold mt-1">Esqueceu a <span className="gold-text">senha</span>?</h1>

          {sent ? (
            <p className="mt-6 text-sm text-muted-foreground">
              Enviamos um e-mail com o link de redefinição. Verifique sua caixa de entrada e a pasta de spam.
            </p>
          ) : (
            <form className="mt-6 space-y-4" onSubmit={submit}>
              <div>
                <Label htmlFor="email">E-mail cadastrado</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
              </div>
              <Button type="submit" disabled={loading} className="gold-btn w-full" data-testid="forgot-submit">
                {loading ? "Enviando..." : "Enviar instruções"}
              </Button>
            </form>
          )}

          <p className="mt-4 text-sm text-center">
            <Link to="/login" className="text-muted-foreground hover:text-foreground">Voltar para o login</Link>
          </p>
        </Card>
      </div>
    </div>
  );
}
